'use strict';

// Import Libraries
import React from 'react';
// Import JS Modules
import classNames from 'classnames';
// Import JSX Modules
import ProductImage from './product-image';

// -----------------------------------------------------------
//  ProductImageThumbnail
// -----------------------------------------------------------
const ProductImageThumbnail = props => {
  const thumbnailUrl = (() => {
    let urlParts = props.thumbnail.split('/');

    urlParts[urlParts.length - 1] = urlParts[urlParts.length - 1].replace(
      /^_hd_product/,
      '_hd_thm_product'
    );

    return urlParts.join('/');
  })();

  return (
    <div
      className={classNames(
        'thumbnail d-flex align-items-center justify-content-center',
        { selected: props.selected }
      )}
      role="radio"
      aria-checked={props.selected}
      onClick={handleClick}
      onKeyDown={onKeyPressed}
      tabIndex="0">
      <ProductImage {...props} url={thumbnailUrl} optionAsset={props.index == 0 && props.optionAsset}/>
    </div>
  );

  function handleClick() {
    props.onClick(props.index);
  }

  function onKeyPressed(event) {
    if (event.keyCode === 13) {
      props.onClick(props.index);
    }
  }
};

export default ProductImageThumbnail;
